import { free } from "../free/themes/freeThemes";
import { plurall } from "../plurall/themes/plurallThemes";
import { premium } from "../premium/themes/premiumThemes";
import { ThemeSet, UserGroup } from "../types";

export const themes: { [key in UserGroup]: ThemeSet } = {
  free,
  premium,
  plurall
};
